<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Place </th>
        <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="status"> Statut</th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="{red: element?.status == 'Occupied', green: element?.status == 'Free'}"> {{element?.status ===
            'Occupied'? 'Occupée' : 'Libre'}} </td>
    </ng-container>

    <ng-container matColumnDef="statusTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="statusTime"> Date de stationnement </th>
        <td mat-cell *matCellDef="let element"> {{ element?.status ===
            'Free'? '-' : formatDate(element?.statusTime) | date: "medium" }} </td>
    </ng-container>

    <ng-container matColumnDef="timeLimitExceeded">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="timeLimitExceeded"> Temps de stationnement </th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="{red: timeIsExceeded(element?.statusTime, element?.status) , green: !timeIsExceeded(element?.statusTime, element?.status)}">
            {{getTimeLimiteExceeded(element?.statusTime, element?.status)}} </td>
    </ng-container>

    <ng-container matColumnDef="id" *ngIf="isAdmin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id"> id </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef=" displayedColumnsAdmin"></tr>
    <tr mat-row *matRowDef="let row; columns:  displayedColumnsAdmin "></tr>

</table>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
    [color]="color">
</mat-paginator>